import { initConfig } from './AppConfig';

// a module with side effect to init the app config before the other modules
initConfig();
